
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import BookingForm from '../../components/BookingForm';



const packages = [
  {
    id: 0,
    name: "Photography Only",
    price: 550,
    photo: true,
    features: [
      "Professional Real Estate Photos",
      "Drone Photos",
      "High-Resolution Images",
      "Professional Editing",
      "Floor Plan Included",
      "24 Hour Delivery"
    ]
  },
  {
    id: 1,
    name: "Videography Only",
    price: 660,
    features: [
      "4K Video Highlight",
      "40-60 Second Edit",
      "Copyright Free Music",
      "Drone Video (If laws allow)"
    ]
  },
  {
    id: 2,
    name: "Combo Package",
    price: 1100,
    popular: true,
    photo: true,
    features: [
      "4K Video Highlight & Photos",
      "40-60 Second Edit",
      "Copyright Free Music",
      "Drone Video & Photos (If laws allow)",
      "Photos",
      "Floor Plan"
    ]
  }
];

const addOns = [
  { name: "Agent Feature (Intro)", price: 110 },
  { name: "Agent Feature (Whole Video)", price: 275 },
  { name: "Day To Dusk", price: 165 },
  { name: "Rush Fee", price: 220 },
  { name: "Vertical Coming Soon", price: 165 },
  { name: "Vertical Edit Of Main Video", price: 110 },
  { name: "Vertical Sold", price: 165 }
];

const portfolioVideos = [
  {
    id: 1,
    title: "Luxury Living On Castle Hill",
    videoId: "wtCqoBYhetM",
    thumbnail: "https://img.youtube.com/vi/wtCqoBYhetM/maxresdefault.jpg",
    location: "Castle Hill",
    type: "full"
  },
  {
    id: 2,
    title: "Penthouse in Townsville CBD",
    videoId: "Lh52yy-t-4E",
    thumbnail: "https://img.youtube.com/vi/Lh52yy-t-4E/maxresdefault.jpg",
    location: "Townsville City",
    type: "full"
  },
  {
    id: 3,
    title: "Built For Big Living",
    videoId: "8KK2bgMjIhE",
    thumbnail: "https://img.youtube.com/vi/8KK2bgMjIhE/maxresdefault.jpg",
    location: "Currajong",
    type: "full"
  },
  {
    id: 4,
    title: "Luxury City Living",
    videoId: "dBEpyQCudik",
    thumbnail: "https://img.youtube.com/vi/dBEpyQCudik/maxresdefault.jpg",
    location: "Townsville City",
    type: "short"
  },
  {
    id: 5,
    title: "Effortless Luxury",
    videoId: "8B80JbDZAYA",
    thumbnail: "https://img.youtube.com/vi/8B80JbDZAYA/maxresdefault.jpg",
    location: "Idalia",
    type: "short"
  },
  {
    id: 6,
    title: "A View-Led Masterpiece",
    videoId: "5592P1Evspc",
    thumbnail: "https://img.youtube.com/vi/5592P1Evspc/maxresdefault.jpg",
    location: "Bushland Beach",
    type: "short"
  },
  {
    id: 7,
    title: "Set For Auction",
    videoId: "1Xt29LTqqOQ",
    thumbnail: "https://img.youtube.com/vi/1Xt29LTqqOQ/maxresdefault.jpg",
    location: "",
    type: "short"
  }
];

export default function RealEstate() {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedAddOns, setSelectedAddOns] = useState([]);
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedGalleryImage, setSelectedGalleryImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handlePackageSelect = (pkg) => {
    setSelectedPackage(pkg);
    setShowBookingForm(true);
  };

  const handleAddOnToggle = (addOn) => {
    setSelectedAddOns(prev => {
      const exists = prev.find(item => item.name === addOn.name);
      if (exists) {
        return prev.filter(item => item.name !== addOn.name);
      } else {
        return [...prev, addOn];
      }
    });
  };

  const getTotalPrice = () => {
    const packagePrice = selectedPackage?.price || 0;
    const addOnPrice = selectedAddOns.reduce((sum, addOn) => sum + addOn.price, 0);
    return packagePrice + addOnPrice;
  };

  // Gallery images
  const galleryImages = [
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/2lw4nwn6_Hale%20Street%20Drone%201.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/0oylx90v_Hale%20Floor%20Plan%20Measurements.PNG",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/6lbxwoxw_15.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/9sd7p5m9_22.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/4k0x4j56_Hale%20Floor%20Plan.JPG",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/jg0s0vo7_Hale%20Street%20Drone%204.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/9e11s21c_Hale%20Street%20Drone%205.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/w6r3hn54_Hale%20Street%20Drone%206.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/5hz4yqit_Hale%20Street%20Drone%202.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/x9ltooqp_Hale%20Street%20Drone%203.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/tvv15zh7_18.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/5p8fr9nk_19.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/pwyugl28_14.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/bdhriuj7_16.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/dntu3x7e_17.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/3hbudfy6_23.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/pext4gsc_24.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/jbzjsqcc_25.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/9usii1l7_20.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/w27i6plj_21.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/i69yw7gh_10.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/4nidqlcf_5.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/c9af291q_6.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/zy2p1h79_7.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/xlhnhe9e_9.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/nc8tj3mp_13.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/jq0jnv13_1.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/3xkg9sbr_2.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/s9ydm04v_11.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/7075jicu_12.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/p2ip4twy_4.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/lnuxu24j_8.jpg",
    "https://customer-assets.emergentagent.com/job_mincham-appointments/artifacts/nnospa4u_3.jpg"
  ];

  const openGallery = (index) => {
    setCurrentImageIndex(index);
    setSelectedGalleryImage(galleryImages[index]);
  };

  const closeGallery = () => {
    setSelectedGalleryImage(null);
  };

  const nextImage = () => {
    const newIndex = (currentImageIndex + 1) % galleryImages.length;
    setCurrentImageIndex(newIndex);
    setSelectedGalleryImage(galleryImages[newIndex]);
  };

  const previousImage = () => {
    const newIndex = (currentImageIndex - 1 + galleryImages.length) % galleryImages.length;
    setCurrentImageIndex(newIndex);
    setSelectedGalleryImage(galleryImages[newIndex]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    
    // Add package and add‑on details
    formData.append('selected_package', selectedPackage?.name || '');
    formData.append('package_price', selectedPackage?.price?.toString() || '0');
    formData.append('selected_addons', selectedAddOns.map(addon => addon.name).join(', '));
    formData.append('addons_price', selectedAddOns.reduce((sum, addon) => sum + addon.price, 0).toString());
    formData.append('total_price', getTotalPrice().toString());

    const submitUrl = selectedPackage?.name === "Photography Only" 
      ? 'https://readdy.ai/api/form/d3icvlp3290jal8ud0lg'
      : 'https://readdy.ai/api/form/d3icvlp3290jal8ud0lg';

    try {
      const response = await fetch(submitUrl, {
        method: 'POST',
        body: new URLSearchParams(formData)
      });

      if (response.ok) {
        alert('Booking submitted successfully! We will contact you soon.');
        setShowBookingForm(false);
        setSelectedPackage(null);
        setSelectedAddOns([]);
      } else {
        alert('There was an error submitting your booking. Please try again.');
      }
    } catch (error) {
      alert('There was an error submitting your booking. Please try again.');
    }
  };

  const handleVideoClick = (video) => {
    setSelectedVideo(video);
  };

  const closeVideoModal = () => {
    setSelectedVideo(null);
  };

  // Initialise Calendly widget when the modal opens

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50">
      {/* Navigation */}
      <Navbar variant="light" position="absolute" />

      {/* Hero Section with Video Banner */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Video Background - Desktop */}
        <div className="absolute inset-0 w-full h-full hidden md:block">
          <iframe
            src="https://www.youtube.com/embed/MrdXw21beDA?autoplay=1&mute=1&loop=1&playlist=MrdXw21beDA&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&playsinline=1"
            title="Real Estate Video Background"
            className="w-full h-full object-cover"
            style={{ minWidth: '100%', minHeight: '100%', transform: 'scale(1.1)' }}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
          {/* Video Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
        </div>

        {/* Video Background - Mobile (Shorts) */}
        <div className="absolute inset-0 w-full h-full md:hidden">
          <iframe
            src="https://www.youtube.com/embed/U1mZ-M2S7OY?autoplay=1&mute=1&loop=1&playlist=U1mZ-M2S7OY&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&playsinline=1"
            title="Real Estate Mobile Video Background"
            className="w-full h-full object-cover"
            style={{ minWidth: '100%', minHeight: '100%', transform: 'scale(1.1)' }}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
          {/* Video Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
        </div>

        <div className="relative z-10 text-center px-6 max-w-6xl mx-auto text-white">
          <div className="mb-8">
            <span className="inline-block px-8 py-3 bg-white/20 backdrop-blur-sm rounded-full text-white font-semibold text-sm tracking-wider border border-white/30">
              PREMIUM REAL ESTATE VIDEOGRAPHY
            </span>
          </div>
          <h1 className="text-6xl md:text-8xl font-black mb-8 tracking-tight leading-none text-white drop-shadow-2xl">
            SHOWCASE
            <span className="block bg-gradient-to-r from-teal-400 via-emerald-400 to-cyan-400 bg-clip-text text-transparent">
              PERFECTION
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-4xl mx-auto leading-relaxed mb-12 font-light drop-shadow-lg">
            Professional videography that transforms properties into must-see experiences, helping buyers envision their dream home
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button
              onClick={() => document.getElementById('packages')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-10 py-4 bg-gradient-to-r from-teal-600 to-emerald-600 text-white font-bold text-lg rounded-full hover:from-teal-700 hover:to-emerald-700 transition-all duration-300 transform hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              VIEW PACKAGES
            </button>
            <button
              onClick={() => document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-10 py-4 bg-white/20 backdrop-blur-sm border-2 border-white/50 text-white font-bold text-lg rounded-full hover:bg-white/30 hover:border-white/70 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-2xl"
            >
              VIEW PORTFOLIO
            </button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <div className="animate-bounce">
            <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
              <div className="w-1 h-3 bg-white/70 rounded-full mt-2 animate-pulse"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section id="portfolio" className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-20">
            <span className="inline-block px-8 py-3 bg-teal-100 rounded-full text-teal-700 font-semibold text-sm tracking-wider border border-teal-200 mb-6">
              OUR WORK
            </span>
            <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-8 tracking-tight">
              Portfolio Showcase
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Explore our recent real estate videography projects across Townsville and surrounding areas
            </p>
          </div>

          {/* Custom Grid Layout for Mixed Video Types */}
          <div className="max-w-7xl mx-auto">
            <div className="space-y-8">
              {/* First Row: 2 Horizontal Videos */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {portfolioVideos.filter(video => video.type === 'full').slice(0, 2).map(video => (
                  <div key={video.id} className="group cursor-pointer">
                    <div
                      className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                      onClick={() => handleVideoClick(video)}
                      style={{ aspectRatio: '16/9' }}
                    >
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                          <h3 className="text-xl font-bold mb-2 leading-tight">{video.title}</h3>
                          <p className="text-teal-200 flex items-center text-base">
                            <i className="ri-map-pin-line mr-2"></i>
                            {video.location}
                          </p>
                        </div>
                      </div>
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="bg-gray-900/90 backdrop-blur-sm rounded-full flex items-center justify-center border border-gray-700/50 shadow-lg w-16 h-16">
                          <i className="ri-play-fill text-white text-2xl ml-1"></i>
                        </div>
                      </div>
                      <div className="absolute top-4 right-4">
                        <div className="bg-black/70 backdrop-blur-sm rounded-full px-3 py-1 text-white text-sm font-medium">
                          Full Video
                        </div>
                      </div>
                    </div>
                    <div className="mt-4 text-center">
                      <h3 className="text-lg font-semibold text-gray-900 mb-1 leading-tight">{video.title}</h3>
                      <p className="text-gray-600 text-base">{video.location}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Second Row: 4 Vertical Videos */}
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
                {portfolioVideos.filter(video => video.type === 'short').map(video => (
                  <div key={video.id} className="group cursor-pointer">
                    <div
                      className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                      onClick={() => handleVideoClick(video)}
                      style={{ aspectRatio: '9/16' }}
                    >
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                          <h3 className="text-base font-bold mb-2 leading-tight">{video.title}</h3>
                          <p className="text-teal-200 flex items-center text-sm">
                            <i className="ri-map-pin-line mr-2"></i>
                            {video.location}
                          </p>
                        </div>
                      </div>
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="bg-gray-900/90 backdrop-blur-sm rounded-full flex items-center justify-center border border-gray-700/50 shadow-lg w-12 h-12">
                          <i className="ri-play-fill text-white text-lg ml-1"></i>
                        </div>
                      </div>
                      <div className="absolute top-4 right-4">
                        <div className="bg-teal-600/90 backdrop-blur-sm rounded-full px-3 py-1 text-white text-xs font-medium">
                          Short
                        </div>
                      </div>
                    </div>
                    <div className="mt-4 text-center">
                      <h3 className="text-base font-semibold text-gray-900 mb-1 leading-tight">{video.title}</h3>
                      <p className="text-gray-600 text-sm">{video.location}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Third Row Horizontal Videos (if any) */}
              {portfolioVideos.filter(video => video.type === 'full').slice(2).length > 0 && (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {portfolioVideos.filter(video => video.type === 'full').slice(2).map(video => (
                    <div key={video.id} className="group cursor-pointer">
                      <div
                        className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                        onClick={() => handleVideoClick(video)}
                        style={{ aspectRatio: '16/9' }}
                      >
                        <img
                          src={video.thumbnail}
                          alt={video.title}
                          className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                            <h3 className="text-xl font-bold mb-2 leading-tight">{video.title}</h3>
                            <p className="text-teal-200 flex items-center text-base">
                              <i className="ri-map-pin-line mr-2"></i>
                              {video.location}
                            </p>
                          </div>
                        </div>
                        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <div className="bg-gray-900/90 backdrop-blur-sm rounded-full flex items-center justify-center border border-gray-700/50 shadow-lg w-16 h-16">
                            <i className="ri-play-fill text-white text-2xl ml-1"></i>
                          </div>
                        </div>
                        <div className="absolute top-4 right-4">
                          <div className="bg-black/70 backdrop-blur-sm rounded-full px-3 py-1 text-white text-sm font-medium">
                            Full Video
                          </div>
                        </div>
                      </div>
                      <div className="mt-4 text-center">
                        <h3 className="text-lg font-semibold text-gray-900 mb-1 leading-tight">{video.title}</h3>
                        <p className="text-gray-600 text-base">{video.location}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Photo Gallery Section */}
          <div className="max-w-7xl mx-auto mt-20">
            <div className="text-center mb-12">
              <h3 className="text-4xl font-bold text-gray-900 mb-4">Photo Gallery</h3>
              <p className="text-lg text-gray-600">Click to view our professional real estate photography work</p>
            </div>
            
            {/* Compact Thumbnail Grid - Only 4 preview images */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
              {galleryImages.slice(0, 4).map((image, index) => (
                <div
                  key={index}
                  onClick={() => openGallery(index)}
                  className="relative aspect-square overflow-hidden rounded-lg cursor-pointer group shadow-md hover:shadow-xl transition-all duration-300"
                >
                  <img
                    src={image}
                    alt={`Gallery ${index + 1}`}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                    <i className="ri-search-line text-white text-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                  </div>
                </div>
              ))}
            </div>
            
            {/* View All Button */}
            <div className="text-center mt-8">
              <button
                onClick={() => openGallery(0)}
                className="inline-flex items-center px-8 py-3 bg-gradient-to-r from-teal-600 to-emerald-600 text-white font-semibold rounded-full hover:from-teal-700 hover:to-emerald-700 transition-all duration-300 transform hover:scale-105 shadow-lg cursor-pointer"
              >
                <i className="ri-image-line mr-2 text-xl"></i>
                View All {galleryImages.length} Photos
              </button>
            </div>
          </div>

          <div className="text-center mt-16">
            <Link
              to="/contact"
              className="inline-block px-10 py-4 bg-gradient-to-r from-teal-600 to-emerald-600 text-white font-bold text-lg rounded-full hover:from-teal-700 hover:to-emerald-700 transition-all duration-300 transform hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
            >
              DISCUSS YOUR PROJECT
            </Link>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {selectedVideo && (
        <div className="fixed inset-0 bg-black/95 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="relative w-full max-w-6xl mx-auto">
            {/* Close Button - Top Right (Desktop) */}
            <button
              onClick={closeVideoModal}
              className="absolute -top-12 right-0 text-white hover:text-gray-300 cursor-pointer transition-colors z-10 hidden md:block"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>

            {/* Close Button - Inside Modal (Mobile-friendly) */}
            <button
              onClick={closeVideoModal}
              className="absolute top-4 right-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white rounded-full p-2 cursor-pointer transition-all z-20"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>

            <div className="relative bg-black rounded-2xl overflow-hidden shadow-2xl">
              {selectedVideo.type === 'short' ? (
                // Vertical video display ONLY for shorts
                <div className="flex justify-center bg-black">
                  <div className="relative" style={{ width: '360px', height: '640px' }}>
                    <iframe
                      src={`https://www.youtube.com/embed/${selectedVideo.videoId}?autoplay=1&rel=0&modestbranding=1&vq=hd1440`}
                      title={selectedVideo.title}
                      className="w-full h-full border-0"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              ) : (
                // Horizontal video display for full videos
                <div className="aspect-video">
                  <iframe
                    src={`https://www.youtube.com/embed/${selectedVideo.videoId}?autoplay=1&rel=0&modestbranding=1&vq=hd1440`}
                    title={selectedVideo.title}
                    className="w-full h-full"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              )}

              <div className="p-6 bg-gradient-to-r from-gray-900 to-black text-white">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-2xl font-bold mb-2">{selectedVideo.title}</h3>
                    <p className="text-gray-300 flex items-center">
                      <i className="ri-map-pin-line mr-2"></i>
                      {selectedVideo.location}
                    </p>
                  </div>
                  <div className="text-right">
                    <span
                      className={`inline-block px-4 py-2 rounded-full text-sm font-medium ${
                        selectedVideo.type === 'short' ? 'bg-teal-500 text-white' : 'bg-gray-700 text-gray-200'
                      }`}
                    >
                      {selectedVideo.type === 'short' ? 'YouTube Short' : 'Full Video'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Gallery Lightbox Modal */}
      {selectedGalleryImage && (
        <div className="fixed inset-0 bg-black/95 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="relative w-full h-full max-w-7xl mx-auto flex items-center justify-center">
            {/* Close Button */}
            <button
              onClick={closeGallery}
              className="absolute top-4 right-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white rounded-full p-3 cursor-pointer transition-all z-30"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>

            {/* Previous Button */}
            <button
              onClick={previousImage}
              className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white rounded-full p-3 cursor-pointer transition-all z-30"
            >
              <i className="ri-arrow-left-s-line text-3xl"></i>
            </button>

            {/* Next Button */}
            <button
              onClick={nextImage}
              className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white rounded-full p-3 cursor-pointer transition-all z-30"
            >
              <i className="ri-arrow-right-s-line text-3xl"></i>
            </button>

            {/* Image Display */}
            <div className="relative max-w-full max-h-full flex items-center justify-center">
              <img
                src={selectedGalleryImage}
                alt={`Gallery ${currentImageIndex + 1}`}
                className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
              />
              
              {/* Image Counter */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/70 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium">
                {currentImageIndex + 1} / {galleryImages.length}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Packages Section */}
      <section id="packages" className="py-32 bg-gradient-to-br from-gray-50 to-teal-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-20">
            <span className="inline-block px-8 py-3 bg-teal-100 rounded-full text-teal-700 font-semibold text-sm tracking-wider border border-teal-200 mb-6">
              CHOOSE YOUR PACKAGE
            </span>
            <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-8 tracking-tight">
              Real Estate Packages
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-12">
              Professional videography packages designed to showcase your property at its absolute best
            </p>

            {/* Add‑ons Preview */}
            <div className="bg-gradient-to-r from-teal-50 to-emerald-50 rounded-2xl p-8 max-w-4xl mx-auto border border-teal-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">✨ Available Add‑ons for All Packages</h3>
              <p className="text-gray-600 mb-6">Select any combination of these premium add‑ons to enhance your chosen package:</p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                {addOns.map((addOn, index) => (
                  <div key={index} className="bg-white rounded-lg p-3 border border-teal-200">
                    <div className="font-semibold text-gray-800 text-xs leading-tight mb-1">{addOn.name}</div>
                    <div className="text-teal-600 font-bold">+A${addOn.price}</div>
                  </div>
                ))}
              </div>
              <p className="text-sm text-gray-500 mt-4">💡 Select your add‑ons below and they'll be included with any package you choose</p>
            </div>
          </div>

          {/* Add‑ons Selection */}
          <div className="max-w-6xl mx-auto mb-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">Select Your Add‑ons</h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {addOns.map((addOn, index) => {
                const isSelected = !!selectedAddOns.find(item => item.name === addOn.name);
                return (
                  <div
                    key={index}
                    onClick={() => handleAddOnToggle(addOn)}
                    className={`relative bg-white rounded-2xl p-6 border-2 transition-all duration-300 cursor-pointer hover:scale-105 hover:shadow-lg ${
                      isSelected
                        ? 'border-teal-500 shadow-lg shadow-teal-500/20 bg-gradient-to-br from-teal-50 to-emerald-50'
                        : 'border-gray-200 hover:border-teal-300'
                    }`}
                  >
                    <div className="flex justify-between items-start mb-4">
                      <div className="flex-1">
                        <h4 className="font-bold text-gray-900 mb-2 text-base leading-tight">{addOn.name}</h4>
                        <p className="text-2xl font-black text-teal-600">+A${addOn.price}.00</p>
                      </div>
                      <div
                        className={`w-8 h-8 rounded-full border-2 flex items-center justify-center transition-all duration-300 ${
                          isSelected ? 'bg-gradient-to-r from-teal-500 to-emerald-500 border-teal-500' : 'border-gray-300 hover:border-teal-400'
                        }`}
                      >
                        {isSelected && <i className="ri-check-line text-white text-lg"></i>}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {selectedAddOns.length > 0 && (
              <div className="mt-8 bg-gradient-to-r from-teal-50 to-emerald-50 rounded-2xl p-6 border border-teal-200">
                <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-check-double-line text-teal-600 mr-2"></i>
                  Selected Add‑ons ({selectedAddOns.length})
                </h4>
                <div className="grid md:grid-cols-2 gap-4 mb-4">
                  {selectedAddOns.map((addOn, index) => (
                    <div key={index} className="flex justify-between items-center text-gray-700 bg-white rounded-lg p-3 border border-teal-200">
                      <span className="font-medium">{addOn.name}</span>
                      <span className="font-bold text-teal-600">+A${addOn.price}.00</span>
                    </div>
                  ))}
                </div>
                <div className="border-t border-teal-200 pt-4">
                  <div className="flex justify-between items-center text-xl font-bold text-gray-900">
                    <span>Add‑ons Total:</span>
                    <span className="text-teal-600">
                      A${selectedAddOns.reduce((sum, addon) => sum + addon.price, 0)}.00
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Packages Grid - Centered for 3 packages */}
          <div className="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {packages.map(pkg => (
              <div key={pkg.id} className={`relative group ${pkg.popular ? 'lg:scale-110 lg:-mt-8' : ''}`}>
                {pkg.popular && (
                  <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 z-20">
                    <div className="bg-gradient-to-r from-teal-600 to-emerald-600 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg">
                      MOST POPULAR
                    </div>
                  </div>
                )}
                <div
                  className={`relative bg-white rounded-3xl p-8 h-full transition-all duration-500 hover:scale-105 shadow-lg hover:shadow-xl ${
                    pkg.popular ? 'border-2 border-teal-500 shadow-teal-500/20' : 'border border-gray-200'
                  }`}
                >
                  <div className="text-center mb-8">
                    <h3 className="text-3xl font-bold mb-4 text-gray-900">{pkg.name}</h3>
                    <div className="flex items-baseline justify-center mb-2">
                      <span className="text-5xl font-black text-gray-900">${pkg.price}</span>
                      <span className="text-gray-500 ml-2">incl GST</span>
                    </div>

                    {selectedAddOns.length > 0 && (
                      <div className="mt-4 p-3 bg-teal-50 rounded-lg border border-teal-200">
                        <p className="text-sm text-teal-700 font-medium">With your selected add‑ons:</p>
                        <p className="text-2xl font-bold text-teal-600">
                          A${pkg.price + selectedAddOns.reduce((sum, addon) => sum + addon.price, 0)}.00
                        </p>
                      </div>
                    )}
                  </div>

                  <ul className="space-y-4 mb-8">
                    {pkg.features.map((feature, i) => (
                      <li key={i} className="flex items-start">
                        <div className="w-6 h-6 bg-gradient-to-r from-teal-500 to-emerald-500 rounded-full flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                          <i className="ri-check-line text-white text-sm"></i>
                        </div>
                        <span className="text-gray-700 leading-relaxed">{feature}</span>
                      </li>
                    ))}

                    {selectedAddOns.length > 0 && (
                      <>
                        <li className="border-t border-gray-200 pt-4">
                          <div className="text-teal-600 font-semibold mb-2 text-sm">+ Your Selected Add‑ons:</div>
                        </li>
                        {selectedAddOns.map((addOn, i) => (
                          <li key={i} className="flex items-start">
                            <div className="w-6 h-6 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-full flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                              <i className="ri-add-line text-white text-sm"></i>
                            </div>
                            <span className="text-gray-700 leading-relaxed">{addOn.name}</span>
                          </li>
                        ))}
                      </>
                    )}
                  </ul>

                  {pkg.photo && (
                    <p data-testid={`cubicasa-note-${pkg.id}`} className="mb-6 text-center text-green-600 font-bold italic leading-snug">
                      "CubiCasa Floor Plans Included with All Interior Photo Shoots."
                    </p>
                  )}

                  <button
                    onClick={() => handlePackageSelect(pkg)}
                    className={`w-full py-4 px-6 rounded-2xl font-bold text-lg transition-all duration-300 cursor-pointer whitespace-nowrap ${
                      pkg.popular
                        ? 'bg-gradient-to-r from-teal-600 to-emerald-600 text-white hover:from-teal-700 hover:to-emerald-700 shadow-lg hover:shadow-teal-500/30'
                        : 'bg-gray-900 text-white hover:bg-gray-800'
                    }`}
                  >
                    Book {pkg.name}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Booking Form Modal - Custom Implementation */}
      {showBookingForm && selectedPackage && (
        <BookingForm
          selectedPackage={selectedPackage}
          selectedAddOns={selectedAddOns}
          onClose={() => {
            setShowBookingForm(false);
            setSelectedPackage(null);
            setSelectedAddOns([]);
          }}
          getTotalPrice={getTotalPrice}
        />
      )}
      {/* Footer */}
      <footer className="bg-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            {/* Company Info */}
            <div className="md:col-span-1">
              <div className="flex items-center space-x-3 mb-4">
                <img
                  src="https://images.squarespace-cdn.com/content/v1/6329980709c417765c18ef9c/1663928993488-9PHELX1GHR1MGT4SNOLP/minchio+brothers+logo.png?format=100w"
                  alt="Minchio Brothers Logo"
                  className="h-10 w-10"
                />
                <span className="text-gray-900 font-bold text-lg">MINCHIO BROTHERS</span>
              </div>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                Professional videography services across Queensland, specializing in Real Estate, Commercial, and Social Media content.
              </p>
              <div className="flex space-x-3">
                <a href="https://www.instagram.com/minchiobrothers/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                  <i className="ri-instagram-fill text-white text-lg"></i>
                </a>
                <a href="mailto:media@matthewminchio.com" className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                  <i className="ri-mail-fill text-white text-lg"></i>
                </a>
                <a href="tel:+61431323137" className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                  <i className="ri-phone-fill text-white text-lg"></i>
                </a>
              </div>
            </div>

            {/* Services */}
            <div>
              <h3 className="text-gray-900 font-bold mb-4">Services</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/real-estate" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Real Estate Videography</Link></li>
                <li><Link to="/commercial" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Commercial Production</Link></li>
                <li><Link to="/social-media" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Social Media Content</Link></li>
                <li><span className="text-gray-600">Drone Videography</span></li>
                <li><span className="text-gray-600">Event Coverage</span></li>
                <li><span className="text-gray-600">Brand Storytelling</span></li>
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-gray-900 font-bold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/reviews" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Client Reviews</Link></li>
                <li><Link to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Contact Us</Link></li>
                <li><Link to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Get Quote</Link></li>
                <li><a href="https://www.minchsolutions.au" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Minch Solutions</a></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-gray-900 font-bold mb-4">Contact Info</h3>
              <div className="space-y-3 text-sm">
                <div className="flex items-start space-x-2">
                  <i className="ri-phone-line text-gray-600 mt-0.5"></i>
                  <div>
                    <a href="tel:+61431323137" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer font-medium">+61 431 323 137</a>
                    <p className="text-gray-500 text-xs">Available 9AM - 6PM</p>
                  </div>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="ri-mail-line text-gray-600 mt-0.5"></i>
                  <div>
                    <a href="mailto:media@matthewminchio.com" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer font-medium">media@matthewminchio.com</a>
                    <p className="text-gray-500 text-xs">24hr response time</p>
                  </div>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="ri-map-pin-line text-gray-600 mt-0.5"></i>
                  <div>
                    <p className="text-gray-600 font-medium">Service Areas:</p>
                    <p className="text-gray-500 text-xs">Townsville, Brisbane, Gold Coast</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm mb-4 md:mb-0">© 2021 MINCHIO BROTHERS. ALL RIGHTS RESERVED</p>
            <div className="flex items-center space-x-4 text-sm">
              <a href="https://www.minchsolutions.au" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-600 cursor-pointer">
                Made by Minchsolutions
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
